import { gql } from "@apollo/client";

export const GET_ALL_INFRASTRUCTURE = gql`
  query GetAllInfrastructure {
    getAllInfrastructure {
      vms {
        id
        name
        status
        vmType
        publicIpAddress
        billingType
        region
        resourceGroup
      }
      tags {
        id
        key
        value
      }
      vmTags {
        vmId
        tagId
      }
    }
  }
`;